/* Product page: gallery + variant selection. */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------- gallery */
  var main = $('[data-gallery-main]');
  $$('[data-gallery-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!main) return;
      var full = btn.getAttribute('data-full');
      if (full) { main.src = full; main.removeAttribute('srcset'); }
      $$('[data-gallery-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
      btn.setAttribute('aria-current', 'true');
    });
  });

  /* ------------------------------------------------------------ variants */
  var dataEl = $('[data-variant-json]');
  if (!dataEl) return;

  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!Array.isArray(variants) || !variants.length) return;

  var idInput = $('[data-variant-id]');
  var addBtn  = $('[data-add-btn]');
  var priceEl = $('[data-price]');
  var S = (window.NXT && window.NXT.strings) || {};

  function selected() {
    var out = [];
    $$('.opt').forEach(function (group) {
      var on = $('[aria-checked="true"]', group);
      out.push(on ? on.getAttribute('data-value') : null);
    });
    return out;
  }

  function match(values) {
    return variants.find(function (v) {
      return values.every(function (val, i) {
        return val === null || v.options[i] === val;
      });
    });
  }

  function money(cents) {
    var fmt = (window.NXT && window.NXT.moneyFormat) || '{{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  /* Grey out option values that can't combine with the current selection. */
  function markAvailability() {
    var current = selected();
    $$('.opt').forEach(function (group, gi) {
      $$('[data-option-btn]', group).forEach(function (btn) {
        var probe = current.slice();
        probe[gi] = btn.getAttribute('data-value');
        /* only constrain by options chosen before this one */
        for (var i = gi + 1; i < probe.length; i++) probe[i] = null;
        var v = match(probe);
        btn.setAttribute('data-unavailable', (!v || !v.available) ? 'true' : 'false');
      });
    });
  }

  function update() {
    var v = match(selected());

    if (!v) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = S.unavailable || 'Unavailable'; }
      markAvailability();
      return;
    }

    if (idInput) idInput.value = v.id;

    if (priceEl) {
      var html = '<span class="price' + (v.compare_at_price > v.price ? ' price--on-sale' : '') + '">' +
                 '<span class="price__now">' + money(v.price) + '</span>';
      if (v.compare_at_price > v.price) {
        html += '<s class="price__was">' + money(v.compare_at_price) + '</s>';
      }
      priceEl.innerHTML = html + '</span>';
    }

    if (addBtn) {
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? (S.addToCart || 'Add to cart') : (S.soldOut || 'Sold out');
    }

    /* swap gallery to the variant image */
    if (v.featured_image && v.featured_image.src && main) {
      main.src = v.featured_image.src;
      main.removeAttribute('srcset');
    }

    /* keep the URL shareable */
    if (window.history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
    }

    markAvailability();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-option-btn]');
    if (!btn) return;
    var group = btn.closest('.opt');
    $$('[data-option-btn]', group).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
    btn.setAttribute('aria-checked', 'true');
    update();
  });

  markAvailability();
})();
